(function () {

  'use strict';

  eclipseApp.directive('usageDetails', function () {
    return {
      restrict: 'E',
      scope: {
        billingCycleInfo: '=',
        newCycleStart: '=',
        ctn: '=',
        ban: '='
      },
      replace: true,
      templateUrl: 'modules/core/views/usage-details.html',
      controller: 'usageDetailsCtrl'

    };
  });

})();
